/* eslint-disable */
const getters = {
  getColors(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
